/* -------------------------------------------------------------------------- */
/*                                  🔲 Button                                 */
/* -------------------------------------------------------------------------- */

import './index.scss'
import React from 'react'

interface IReactButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
}

interface ICustomButtonProps {
  buttonType: 'primary' | 'secondary'
}

// Only used for docs
export class CustomButtonProps extends React.Component<ICustomButtonProps> { }

export interface IButtonProps extends ICustomButtonProps, IReactButtonProps { }

export class Button extends React.Component<IButtonProps> {
  static defaultProps: Partial<IButtonProps> = {
    buttonType: 'primary'
  }

  get className() {
    let className = this.props.className ?? ''

    className += ` ${this.props.buttonType}`

    return className
  }

  public render() {
    return (
      <button {...this.props} className={this.className} />
    )
  }
}
